import * as angular from 'angular';

import { PropertyType, ContextualField, ComponentDefinition, multiSelects } from '../../models';
import { GroupSelectionService } from '../../services';
import { severityLevels } from '../../common';
import { AlarmsTableConfiguration } from './alarmsTable.configuration';
import * as Fields from '../../common/helpers/contextual';

class AlarmsTableContextualController implements angular.IComponentController {
    configuration: AlarmsTableConfiguration;
    properties: ContextualField[];
    filters: ContextualField[];
    parameters: ContextualField[];
    levels: string[];
    multiSelects: PropertyType[];

    static $inject = ['groupSelectionService'];

    constructor(private _groupSelectionService: GroupSelectionService) {
    }

    $onInit() {
        this.multiSelects = multiSelects;
        if(this.configuration.alignedOn === undefined){
            this.configuration.alignedOn = 0;
        }
        this.properties = [
            {
                modelName: 'minPeriod',
                propertyType: PropertyType.Frequency,
                label: 'Minimum period',
                propertyName: 'minPeriodProperty',
                required: false,
                icon: 'fa-calendar-minus-o',
                extraData: {
                    intervalUnitName: 'unit',
                    disableFrequencyValidation: true
                }
            }, {
                modelName: 'maxPeriod',
                propertyType: PropertyType.Frequency,
                label: 'Maximum period',
                propertyName: 'maxPeriodProperty',
                required: false,
                icon: 'fa-calendar-plus-o',
                extraData: {
                    intervalUnitName: 'unit',
                    disableFrequencyValidation: true
                }
            }, 
            angular.copy(Fields.PeriodReference),
            {
                modelName: 'showGroup',
                propertyType: PropertyType.Boolean,
                label: 'Group',
                placeholder: 'Group',
                propertyName: 'showGroupProperty',
                required: false,
                icon: 'fa-sitemap'
            }, {
                modelName: 'showIdentifier',
                propertyType: PropertyType.Boolean,
                label: 'Identifier name',
                placeholder: 'Identifier name',
                propertyName: 'showIdentifierProperty',
                required: false,
                icon: 'fa-id-badge'
            }, {
                modelName: 'showTag',
                propertyType: PropertyType.Boolean,
                label: 'Tag',
                placeholder: 'Tag',
                propertyName: 'showTagProperty',
                required: false,
                icon: 'fa-tag'
            }, {
                modelName: 'showUnit',
                propertyType: PropertyType.Boolean,
                label: 'Unit',
                placeholder: 'Unit',
                propertyName: 'showUnitProperty',
                required: false,
                icon: 'fa-balance-scale'
            }, {
                modelName: 'showComment',
                propertyType: PropertyType.Boolean,
                label: 'Comment',
                placeholder: 'Comment',
                propertyName: 'showCommentProperty',
                required: false,
                icon: 'fa-comment-o'
            }, 
            {
                modelName: 'showNumberOfExcursions',
                propertyType: PropertyType.Boolean,
                label: 'Number of excursions',
                placeholder: 'Number of excursions',
                propertyName: 'showNumberOfExcursionsProperty',
                required: false,
                iconText: '#',
                icon: 'fa-bell'
            },
            {
                modelName: 'showExcursionTime',
                propertyType: PropertyType.Boolean,
                label: 'Total excursion time (h)',
                placeholder: 'Total excursion time (h)',
                propertyName: 'showExcursionTimeProperty',
                required: false,
                icon: 'fa-hourglass-end'
            }, {
                modelName: 'showMaxDeviation',
                propertyType: PropertyType.Boolean,
                label: 'Max. deviation',
                placeholder: 'Max. deviation',
                propertyName: 'showMaxDeviationProperty',
                required: false,
                icon: 'fa-arrows-v'
            }, {
                modelName: 'showCurrentValue',
                propertyType: PropertyType.Boolean,
                label: 'Current value',
                placeholder: 'Current value',
                propertyName: 'showCurrentValueProperty',
                required: false,
                icon: 'fa-hashtag'
            }, {
                modelName: 'showTrend',
                propertyType: PropertyType.Boolean,
                label: 'Trend',
                placeholder: 'Trend',
                propertyName: 'showTrendProperty',
                required: false,
                icon: 'fa-line-chart'
            }
        ];
        this.parameters = [
            {
                modelName: 'showLow',
                propertyType: PropertyType.Boolean,
                label: 'Low',
                propertyName: 'showLowProperty',
                required: false,
                icon: 'fa-long-arrow-down'
            },
            {
                modelName: 'showHigh',
                propertyType: PropertyType.Boolean,
                label: 'High',
                propertyName: 'showHighProperty',
                required: false,
                icon: 'fa-long-arrow-up'
            },
            {
                modelName: 'showWeight',
                propertyType: PropertyType.Boolean,
                label: 'Weight',
                propertyName: 'showWeightProperty',
                required: false,
                icon: 'fa-caret-square-o-up'
            },
            {
                modelName: 'showProbabilityOfFailure',
                propertyType: PropertyType.Boolean,
                label: 'Probability of failure',
                propertyName: 'showProbabilityOfFailureProperty',
                required: false,
                icon: 'fa-percent'
            },
            {
                modelName: 'showConsequenceOfFailure',
                propertyType: PropertyType.Boolean,
                label: 'Consequence of failure',
                propertyName: 'showConsequenceOfFailureProperty',
                required: false,
                icon: 'fa-share-alt fa-flip-horizontal'
            },
            {
                modelName: 'showAction',
                propertyType: PropertyType.Boolean,
                label: 'Action',
                propertyName: 'showActionProperty',
                required: false,
                icon: 'fa-hand-o-right'
            }, {
                modelName: 'showCategories',
                propertyType: PropertyType.Boolean,
                label: 'Categories',
                propertyName: 'showCategoriesProperty',
                required: false,
                icon: 'fa-tags'
            }
        ];
        const boundDisabled = this._groupSelectionService.selectedGroup() === null || this._groupSelectionService.selectedGroup() === undefined;
        this.filters = [
            {
                modelName: 'isBoundToGroup',
                propertyType: PropertyType.Boolean,
                label: 'Bind',
                placeholder: 'Bind',
                propertyName: 'isBoundToGroupProperty',
                required: false, extraData: {
                    isDisabled: () => boundDisabled,
                },
                icon: 'fa-anchor'
            },
            angular.copy(Fields.IncludeChildren),
            {
                modelName: 'groupGuids',
                propertyType: PropertyType.MultiGroup,
                label: 'Groups',
                propertyName: 'groupGuidsProperty',
                required: false, extraData: {
                    isDisabled: () => !boundDisabled && this.configuration.filters && this.configuration.filters.isBoundToGroup,
                },
                icon: 'fa-sitemap'
            }, {
                modelName: 'severities',
                propertyType: PropertyType.Severities,
                label: 'Severities',
                propertyName: 'severitiesProperty',
                required: false, extraData: {
                    isDisabled: () => !boundDisabled && this.configuration.filters && this.configuration.filters.isBoundToGroup,
                },
                icon: 'fa-bell'
            }, {
                modelName: 'categories',
                propertyType: PropertyType.AlarmCategories,
                label: 'Filter by category',
                propertyName: 'categoriesProperty',
                icon: 'fa-key'
            }
        ];
        this.levels = severityLevels.map(d => d.value);
    }
}

export const wtAlarmsTableContextual: ComponentDefinition = {
    componentId: 'wtAlarmsTableContextual',
    controller: AlarmsTableContextualController,
    controllerAs: 'vm',
    template: require('./alarmsTable.contextual.html'),
    bindings: {
        configuration: '=',
        formController: '<'
    }
};
